import React from "react";
import { Button, Row, Col, Typography, Space, Card } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const WelcomePage = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>Taskizy - {t('welcome.title')}</title>
      </Helmet>
      
      {/* Hero Section */}
      <section style={{ padding: "80px 20px", textAlign: "center", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <img src="/img/partners.png" style={{width:200}} />
          <Title level={1} style={{ fontColor: "#fff !important", fontSize: "clamp(2rem, 5vw, 3.5rem)", marginBottom: "24px" }}>
            {t('welcome.title')}
          </Title>
          <Paragraph style={{ fontSize: "clamp(1rem, 2.5vw, 1.25rem)", color: "rgba(255,255,255,0.9)", marginBottom: "40px" }}>
            {t('welcome.subtitle')}
          </Paragraph>
          <Link to="/transactions">
            <Button type="primary" size="large" style={{ height: "50px", fontSize: "18px", padding: "0 40px" }}>
              {t('welcome.startNow')}
            </Button>
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: "80px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('welcome.howItWorks')}
          </Title>
          <Row gutter={[32, 32]} align="middle">
            <Col xs={24} md={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>📝</div>
                <Title level={3}>{t('welcome.step1Title')}</Title>
                <Paragraph>{t('welcome.step1Desc')}</Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🎁</div>
                <Title level={3}>{t('welcome.step2Title')}</Title>
                <Paragraph>{t('welcome.step2Desc')}</Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>✅</div>
                <Title level={3}>{t('welcome.step3Title')}</Title>
                <Paragraph>{t('welcome.step3Desc')}</Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('welcome.hourForNetflix')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('welcome.hourForNetflixDesc')}
                </Paragraph>
                <Link to="/marketplace/inquiries">
                  <Button type="primary" size="large">
                    {t('welcome.checkTasks')}
                  </Button>
                </Link>
              </Space>
            </Col>
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>🎯</div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Example Tasks Cards */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('welcome.realTasksTitle')}
          </Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <Card style={{ border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", borderRadius: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                  <div style={{ 
                    width: "40px", 
                    height: "40px", 
                    borderRadius: "50%", 
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    marginRight: "12px"
                  }}>M</div>
                  <div>
                    <div style={{ fontWeight: "500" }}>MarketingPro</div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>Verified Client</div>
                  </div>
                </div>
                <Title level={4} style={{ marginBottom: "8px" }}>{t('welcome.exampleTask1Title')}</Title>
                <Paragraph style={{ color: "#6c757d", marginBottom: "16px" }}>{t('welcome.exampleTask1Desc')}</Paragraph>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ color: "#52c41a", fontWeight: "bold", fontSize: "18px" }}>Netflix 1-month</div>
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>~30 min</div>
                </div>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", borderRadius: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                  <div style={{ 
                    width: "40px", 
                    height: "40px", 
                    borderRadius: "50%", 
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    marginRight: "12px"
                  }}>S</div>
                  <div>
                    <div style={{ fontWeight: "500" }}>StartupGuru</div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>New Client</div>
                  </div>
                </div>
                <Title level={4} style={{ marginBottom: "8px" }}>{t('welcome.exampleTask2Title')}</Title>
                <Paragraph style={{ color: "#6c757d", marginBottom: "16px" }}>{t('welcome.exampleTask2Desc')}</Paragraph>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ color: "#52c41a", fontWeight: "bold", fontSize: "18px" }}>50 PLN Allegro</div>
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>~15 min</div>
                </div>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", borderRadius: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                  <div style={{ 
                    width: "40px", 
                    height: "40px", 
                    borderRadius: "50%", 
                    background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    marginRight: "12px"
                  }}>D</div>
                  <div>
                    <div style={{ fontWeight: "500" }}>DesignStudio</div>
                    <div style={{ fontSize: "12px", color: "#6c757d" }}>Premium Client</div>
                  </div>
                </div>
                <Title level={4} style={{ marginBottom: "8px" }}>{t('welcome.exampleTask3Title')}</Title>
                <Paragraph style={{ color: "#6c757d", marginBottom: "16px" }}>{t('welcome.exampleTask3Desc')}</Paragraph>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ color: "#52c41a", fontWeight: "bold", fontSize: "18px" }}>100 PLN Steam</div>
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>~5 min</div>
                </div>
              </Card>
            </Col>
          </Row>
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <Link to="/marketplace/inquiries">
              <Button type="primary" size="large" style={{ height: "50px", fontSize: "18px", padding: "0 40px" }}>
                {t('welcome.viewAllTasks')}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Task Examples */}
      <section style={{ padding: "80px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>⚡</div>
            </Col>
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('welcome.noTransfers')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('welcome.exampleTasks')}
                </Paragraph>
                <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
                  <li>{t('welcome.task1')}</li>
                  <li>{t('welcome.task2')}</li>
                  <li>{t('welcome.task3')}</li>
                  <li>{t('welcome.task4')}</li>
                  <li>{t('welcome.task5')}</li>
                </ul>
                <Link to="/transactions">
                  <Button type="primary" size="large">
                    {t('welcome.orderTask')}
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </div>
      </section>

      {/* Security Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('welcome.securityFirst')}
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <Title level={4}>{t('welcome.escrowTitle')}</Title>
                <Paragraph>
                  {t('welcome.escrowDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <Title level={4}>{t('welcome.chatTitle')}</Title>
                <Paragraph>
                  {t('welcome.chatDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <Title level={4}>{t('welcome.attachmentsTitle')}</Title>
                <Paragraph>
                  {t('welcome.attachmentsDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                <Title level={4}>{t('welcome.aiTitle')}</Title>
                <Paragraph>
                  {t('welcome.aiDesc')}
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Professional Software Section */}
      <section style={{ padding: "80px 20px", background: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('welcome.professionalSoftware')}
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={8}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>💻</div>
                <Title level={4}>{t('welcome.professionalSoftwareTitle')}</Title>
                <Paragraph>
                  {t('welcome.professionalSoftwareDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚙️</div>
                <Title level={4}>{t('welcome.automatedWorkflow')}</Title>
                <Paragraph>
                  {t('welcome.automatedWorkflowDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card style={{ height: "100%", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🤖</div>
                <Title level={4}>{t('welcome.smartContracts')}</Title>
                <Paragraph>
                  {t('welcome.smartContractsDesc')}
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Brands Section */}
      <section style={{ padding: "60px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
          <Title level={3} style={{ marginBottom: "40px", color: "#6c757d" }}>
            {t('welcome.giftCardsTitle')}
          </Title>
          <div style={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            flexWrap: "wrap", 
            gap: "40px",
            opacity: "0.7"
          }}>
            <img src="/img/Allegro.pl_sklep.svg.png" style={{ height: "40px", filter: "grayscale(100%)" }} />
            <img src="/img/Paysafecard_logo.png" style={{ height: "40px", filter: "grayscale(100%)" }} />
            <img src="/img/Logonetflix.png" style={{ height: "40px", filter: "grayscale(100%)" }} />
            <img src="/img/Empik.svg.png" style={{ height: "40px", filter: "grayscale(100%)" }} />
            <img src="/img/Eneba-Logo-Vector.svg--300x93.png" style={{ height: "40px", filter: "grayscale(100%)" }} />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: "80px 20px", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white", textAlign: "center" }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <Title level={2} style={{ color: "white", marginBottom: "24px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('welcome.readyForFirstTask')}
          </Title>
          <Paragraph style={{ fontSize: "18px", color: "rgba(255,255,255,0.9)", marginBottom: "40px" }}>
            {t('welcome.joinThousands')}
          </Paragraph>
          <Space size="large" wrap>
            <Link to="/transactions">
              <Button type="primary" size="large" style={{ height: "50px", fontSize: "18px", padding: "0 40px" }}>
                {t('welcome.orderTaskCTA')}
              </Button>
            </Link>
            <Link to="/marketplace/inquiries">
              <Button size="large" style={{ height: "50px", fontSize: "18px", padding: "0 40px", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.3)", color: "white" }}>
                {t('welcome.findTasksCTA')}
              </Button>
            </Link>
          </Space>
        </div>
      </section>
    </>
  );
};

export default WelcomePage;